import { z } from "zod";
export const loginBodySchema = z.object({
    password: z.string(),
});
export const loginResponseSchema = z.object({
    token: z.string(),
});
//# sourceMappingURL=auth.js.map